export default __webpack_public_path__ + "static/media/Group 10380.f5dc7a43.svg";